import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgSui = function SvgSui(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#4DA2FF"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M79.08 53.365v.003a23.84 23.84 0 0 1 5.214 14.914 23.84 23.84 0 0 1-5.361 15.095l-.289.355-.076-.451a21 21 0 0 0-.23-1.161c-1.678-7.37-7.143-13.69-16.139-18.807-6.074-3.447-9.55-7.596-10.464-12.31-.59-3.05-.151-6.111.696-8.734.847-2.622 2.107-4.82 3.177-6.142l3.5-4.28a1.535 1.535 0 0 1 2.375 0zm5.535-4.275L61.163 20.41a1.12 1.12 0 0 0-1.734 0L35.974 49.09l-.075.096A31.08 31.08 0 0 0 29 68.756C29 86.011 43.011 100 60.295 100s31.296-13.989 31.296-31.244a31.08 31.08 0 0 0-6.899-19.57zm-43.029 4.183 2.099-2.567.063.474q.075.563.184 1.13c1.357 7.122 6.206 13.06 14.313 17.66 7.047 4.01 11.15 8.622 12.332 13.68.493 2.111.58 4.188.367 6.004l-.013.112-.102.05a23.9 23.9 0 0 1-10.534 2.426c-13.254 0-24-10.727-24-23.96 0-5.682 1.981-10.902 5.291-15.01",
        clipRule: "evenodd"
    })));
};

export { SvgSui as ReactComponent };
//# sourceMappingURL=SUI.svg.es.js.map
